<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle"           
          >
          
          <template v-slot:body>
            <v-layout column overflow-auto>
              <v-row>
							<v-col cols="12" class="pa-0">
								<i-card-top
									class="d-md-flex"
									outlined

                  :useBtnList="[
                      'btnRetrieve', //Retrieve
                      'btnPrint',   //Save Excel
                      'btnSaveExcel'
                    ]"
                    @btnRetrieve="btnRetrieve()"                    
                    @btnPrint="btnPrint()"
                    @btnSaveExcel="btnSaveExcel()"                    
								>
									<template v-slot:body>
										<v-row no-gutters class="center pa-0 pl-1">
											<v-col cols="12">
												<v-row dense class="ma-0">														
													<i-label :label="' Ship No :'" />
                          <v-col cols="2">
                            <v-select
                              v-model=" shipNo"
                              :items="shipNoList"
                              return-object
                              item-value="code"
                              item-text="codeName"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="btnRetrieve()"
                            />
                          </v-col>																															
												</v-row>
											</v-col>
										</v-row>
									</template>
								</i-card-top>
							</v-col>
						</v-row>              
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">                
                  <DxDataGrid id="epmsa060" 
                    class="listBox" 
                    :ref="epmsa060Ref"
                    :data-source="gridMainList" :remote-operations="false"
                    :hover-state-enabled="true" :allow-column-resizing="true"
                    :allow-column-reordering="true" :row-alternation-enabled="false"
                    :show-borders="true" :width="grid.width" :show-row-lines="true" key-expr="id"
                    :focused-row-enabled="true" :column-hiding-enabled="false"
                    :selection="{ mode: 'none' }" :sorting="{ mode: 'none' }"                     
                    @rowPrepared="rowPrepared"         
                    >        
                    <DxColumn data-field="rnum" caption= "No" width="5%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="chk"  width="5%" data-type="boolean" alignment="center" cell-template="selChkRow" :allow-editing="false" />                                         
                      <template #selChkRow="{ data: cellInfo }">                        
                        <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :disabled="cellInfo.data.rmk === 'Finish' ? true : false" :onValueChanged="value => onValueChanged(value, cellInfo)" />
                      </template>                      
                    <DxColumn   data-field="shipNo" caption="Ship No" width="10%" data-type="string" alignment="center" :allow-editing="false" /> 
                    <DxColumn   data-field="lotNo" caption="Block" width="10%" data-type="string" alignment="center" :allow-editing="false" />                                       

                    <DxColumn caption= "Lot" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="stlLot" caption="Steel" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="div" caption="Assem" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption= "Order" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="pcsQty" caption="Quantity" width="10%" data-type="number" format="#,###"  alignment="right" :allow-editing="false" />
                      <DxColumn data-field="wgt" caption="Weight" width="10%" data-type="number" format="#,###"  alignment="right" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption= "Cut" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="cutQty" caption="Quantity" width="10%" data-type="number" format="#,###"  alignment="right" :allow-editing="false" />
                      <DxColumn data-field="cutWgt" caption="Weight" width="10%" data-type="number" format="#,###"  alignment="right" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption= "Working Content" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="cut" caption="Cut" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="weld" caption="Weld" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="bend" caption="Bend" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn   data-field="uprc" caption="Unit Price" width="10%" data-type="number" format="#,###"  alignment="right" :allow-editing="false" />                
                    <DxColumn caption= "Paid Info" width="15%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="paidWgt" caption="Weight" width="15%" data-type="number" format="#,###"  alignment="right" :allow-editing="false" />
                      <DxColumn data-field="paidAmt" caption="Amount" width="15%" data-type="number" format="#,###"  alignment="right" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption= "Need to Paid" width="15%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="needWgt" caption="Weight" width="15%" data-type="number" format="#,###"  alignment="right" :allow-editing="false" />
                      <DxColumn data-field="needAmt" caption="Amount" width="15%" data-type="number" format="#,###"  alignment="right" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn   data-field="rmk" caption="Remark" width="10%" data-type="string" alignment="center" :allow-editing="false" /> 

                    <DxSummary>
                      <DxTotalItem column="shipNo" summary-type="count" display-format="TOTAL" />
                      <DxTotalItem column="paidWgt" summary-type="sum" :customize-text="totalFormat" />
                      <DxTotalItem column="paidAmt" summary-type="sum" :customize-text="totalFormat" />
                      <DxTotalItem column="needWgt" summary-type="sum" :customize-text="totalFormat" />
                      <DxTotalItem column="needAmt" summary-type="sum" :customize-text="totalFormat" />
                    </DxSummary>                 	

                  
                    <DxPaging :enabled="true" :page-size="20" />

                  </DxDataGrid>
                </v-col>
              </v-row>
            </v-layout>
          </template> 
        </i-card-vertical>
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn , DxButton , DxExport } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import { getDateFormat, getCurrentDate, getFirstDate , getFirstDay, getNumComma} from '@/utils/common.js'
import { epmsa060List, epmsa060PrtSave, epmsa060PrtDelete, epmsa060Xls } from '@/api/view/hip/A/epmsa060.js'
import { reportView } from '@/api/view/hip/common/common.js'
import { getShipNoList} from '@/api/view/hip/A/epmsa010'

export default {
  name: 'epmsa060',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,    
    DxColumn
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      epmsa060Ref: 'epmsa060Ref',
      gridMainList: [],      
      shipNo: '',
      shipNoList: [],
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epmsa060Ref)
    },
  },
  methods: {

    totalFormat(e) {
      const result = getNumComma(Number(e.value.toFixed(2)), 2)
      return result
    },
    getNumComma(e) {
      const result = getNumComma(e, 2)
      return result
    },
    
    async getShipList(){
      try {
        this.openLoading('searching')
        let param = {
          makerCd: this.makerCd
        }
        
        await getShipNoList(param).then(res => {
          this.shipNoList.push({code: '' , codeName: 'Select'})
          res.list.forEach(e => {
            e.code = e.shipNo
            e.codeName = !e.shipNo ? '' : e.shipNo
            this.shipNoList.push(e)
          });
          this.shipNo = this.shipNoList[0] 
        })
      } finally {
        this.endLoading()
      }
    },

    onValueChanged(value, cellInfo) {
      cellInfo.value = cellInfo.value === 'Y' ? 'N' : 'Y'
      cellInfo.data.chk = cellInfo.value
      // console.log(cellInfo.data.chk)      
    },


    btnRetrieve() {
     
      this.doSearchMain()      
    },

    async doSearchMain() {
      this.openLoading('searching')
      let params = {
        makerCd: this.$store.state.user.makerCd,        
        shipNo: this.shipNo.code
      }      
      
      await epmsa060List(params).then(res => {        
        res.list.forEach(e => {
          this.gridMainList = res.list
        });

      }).finally(() => {
        this.endLoading()
      })

    },

    async doPrtIns() {        
      let params = []  
      //Delete 
      epmsa060PrtDelete().then(res => {           
          }).finally(() => {
            this.endLoading()
          })
      
         //Insert 
      if (this.gridMainList.length > 0) {
        
        await this.gridInstance.saveEditData()        
        let params = []        
        
          
        for (let i = 0; i < this.gridMainList.length; i++) {          

          let list =  this.gridMainList[i]                    


          if (list.chk === "Y") {        
              //  console.log(i + ":" + list.chk)     

                params.push({
                  id: i,
                  rnum: list.rnum,
                  shipNo: list.shipNo,
                  lotNo: list.lotNo,
                  stlLot: list.stlLot,
                  div: list.div,
                  pcsQty: list.pcsQty,
                  wgt: list.wgt,
                  cut: list.cut,
                  weld: list.weld,          
                  bend: list.bend,
                  cutQty: list.cutQty,  
                  cutWgt: list.cutWgt,
                  paidWgt: list.paidWgt,
                  paidAmt: list.paidAmt,
                  uprc: list.uprc,
                  needWgt: list.needWgt,
                  needAmt: list.needAmt,
                  rmk: list.rmk
                })

              }              
        }        
        // console.log("params:", params) 

        this.openLoading('updating')                
        epmsa060PrtSave(params).then(res => {                    
        }).finally(() => {
          this.endLoading()
        })

      }
     
    },


    btnPrint() {

            const paramPrt = {
                fileName: 'epmsa44.jrxml'                
            }
            
            this.doPrtIns()

            this.openLoading('searching')
            reportView(paramPrt)
                .finally(() => {
                    this.endLoading()
                })


        },

    btnSaveExcel(){            
        this.openLoading('Excel Saving')
        let params = {                
            shipNo: this.shipNo.code
          }  
        
        epmsa060Xls(params)
        this.endLoading()
    },        
        

    rowPrepared(e) {
      if (e.rowType === 'data') {
          // set color
          if (e.data.rmk === 'Finish' ) {
             e.rowElement.style.backgroundColor = "#C0E0FF"            
            
          }else if (e.data.wgt ==  e.data.cutWgt){
            if(e.data.paidWgt > 0){
                e.rowElement.style.backgroundColor = "#D03636"       
            } else {
                e.rowElement.style.backgroundColor = "#F5EA14"       
            } 
          }else{
            e.rowElement.style.backgroundColor = "#FFFFFF"       
          }
        

      } 
    }

   },
   mounted() {    
      this.getShipList()
      this.gridInstance.option('defaultPaging', false)
  }


}

</script>
<style lang="scss" scoped>
  .subTitle {
    font-weight: bold;
    color: black;
  }  
  .v-btn {
    text-transform: unset !important;
    // height: 16px !important;
  }
</style>